<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    rate: {
      type: String,
      default: "",
    },
    datas: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.datas);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(datas) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   const yData = datas.map(item => item.name);
  const zData = datas.map(item => item.finished);
  const pData = datas.map(item => item.percent);
  // 设置等长的背景柱状图
  const maxData = new Array(yData.length).fill(100);

    this.state.chart.setOption({
        grid: {
         left: "15%",
         right: "15%",
         bottom: "0%",
         top: "20%",
         containLabel: false
      },
   xAxis: [
      {
         show: true
      },
      {
         show: false,
         splitLine: {
            show: false
         }
      }
   ],
   yAxis: [
      {
         show: true,
         data: yData,
         position: "left",
         axisLabel: {
            lineHeight: 0,
            verticalAlign: "bottom",
            fontSize: 30,
            color: "#00d3dd",
            formatter: "{value}"
         },
         axisLine: {
            show: false
         },
         splitLine: {
            show: false
         },
         axisTick: {
            show: false
         }
      },
      {
         show: true,
         data: zData,
         offset: 5,
         position: "right",
         axisLabel: {
            lineHeight: 0,
            verticalAlign: "bottom",
            fontSize: 30,
            color: "#00D3DD",
            formatter: "{value}"
         },
         axisLine: {
            show: false
         },
         splitLine: {
            show: false
         },
         axisTick: {
            show: false
         }
      }
   ],
   series: [
      {
         name: "进度",
         show: true,
         type: "bar",
         barGap: "-100%",
         xAxisIndex: 1,
         barWidth: 30,
         itemStyle: {
            borderRadius: 20,
            color:function (params) {
            let colorList = [
              ['#FC8C8F', '#FF5597'],
              ['#00FFC3', '#072541'],
            ];
            let colorItem = colorList[params.dataIndex];
            return new echarts.graphic.LinearGradient(0,0,1,0, //y->y2
              [
                {
                  offset: 0,
                  color: colorItem[0]
                },
                {
                  offset: 1,
                  color: colorItem[1]
                }
              ],
              false
            );
          }
            // color: function (params) {
            //    console.log(params.dataIndex)
            // return myColor[params.dataIndex];
            // }
         },
         label: {
            show: false, 
            position: 'insideRight', 
            formatter: '{c}%',
            offset: [-10, 2], 
            color: '#fff'
         },
         labelLine: {
            show: false
         },
         z: 2,
         data: pData,
         animationDelay: 1000,
         animationDuration: 1000
      },
      {
         name: "百分比",
         z: 1,
         show: true,
         type: "bar",
         xAxisIndex: 1,
         barGap: "-100%",
         barWidth: 30,
         itemStyle: {
            borderRadius: 20,
            color: "#1C2E38"
         },
         label: {
            show: false,
         },
         data: maxData
      }
   ]
         
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
